import React, { useState } from "react"
import { useEffect } from "react"
import { createPortal } from "react-dom"

import { USER_ROUTES } from "@constants"
import PageWrapper from "../../@PageWrapper"
import { clearUserSettingsSignals } from "./@signals"
import UserSettingContent from "./Content"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import SettingsDemoData from './VirtualTour/DemoData'
import { isTourDemoActive } from '@signals/app'


export default function UserSettingPage() {
    const [tourActive, setTourActive] = useState(false)

    useEffect(() => {
        return clearUserSettingsSignals
    }, [])

    return <PageWrapper
        head={`DS Rentacar | ${USER_ROUTES.TITLE}`}
        title={USER_ROUTES.TITLE}
        subtitle={USER_ROUTES.SETTINGS_SUBTITLE}
        actions={<VirtualTourButton onClick={() => { setTourActive(true); isTourDemoActive.value = true }} />}
    >
        <UserSettingContent />
        {tourActive && <SettingsDemoData />}
        {tourActive && createPortal(
            <TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
            document.body
        )}
    </PageWrapper>
}